import {
    Store
} from 'vuex';
import {
    IGlobalState
} from '@/store';
import * as Types from '@/store/action-types';
import AREA_TYPE, { IAreaItem } from '@/typings/area';

/**
 * 使用区域列表
 */
export async function useAreaList(store: Store<IGlobalState>, type: AREA_TYPE, id: string) {
    // 从接口获取省列表
    let params = {
        type: type,
        id: id
    }
    await store.dispatch(`area/${Types.SET_AREA_LIST}`, params);
};

// 改变当前选择省、市、 区
export async function setCurrentAreaItem(store: Store<IGlobalState>,type: AREA_TYPE, areaItem: IAreaItem) {
        if (type === AREA_TYPE.PROVINCE_TYPE) {
            store.commit(`area/${Types.SET_AREA_CUR_PROVINCE}`, areaItem);
            store.commit(`area/${Types.SET_AREA_CUR_CITY}`, {id:'',areaName:''});
            store.commit(`area/${Types.SET_AREA_CUR_DISTRICT}`, {id:'',areaName:''});
        } else if (type === AREA_TYPE.CITY_TYPE) {
            store.commit(`area/${Types.SET_AREA_CUR_CITY}`, areaItem);
            store.commit(`area/${Types.SET_AREA_CUR_DISTRICT}`, {id:'',areaName:''});
        } else if (type === AREA_TYPE.DISTRICT_TYPE) {
            store.commit(`area/${Types.SET_AREA_CUR_DISTRICT}`, areaItem);
        }
}